<template>
  <div class="w-imbee-wrapper" :data-open="showWrapper" :data-fullscreen="fullScreen" :style="{
    maxWidth: chat.width,
    maxHeight: chat.height,
    bottom: 0,
    [alignment]: 0,
  }">
    <transition name="imbee-fadeIn" enter-active-class="imbee-fadeInUp" leave-active-class="imbee-fadeOutDown"
      v-on:before-enter="
        () => {
          showWrapper = true;
        }
      " v-on:after-leave="
  () => {
    showWrapper = false;
  }
">
      <Container class="w-imbee-container" @close="close()" v-show="fullScreen ? true : chat.show"
        :full-screen="fullScreen" :data-fullscreen="fullScreen" :header="header" :loader="loader"
        :cookieBanner="cookieBanner" :footer="footer" :humanizacion="humanizacion" :chat="chat" :style="{
          maxWidth: chat.width,
          maxHeight: chat.height,
          bottom: chat.verticalPadding,
          [alignment]: chat.horizontalPadding,
        }" />
    </transition>
    <CallToAction v-if="!fullScreen" :show="
      callToAction.show && callToAction.showCta && bubble.show && !chat.show
    " @open="open()" :opened="chat.show" :alignment="alignment" :call-to-action="callToAction" />
    <Bubble v-if="!fullScreen" @clicked="toggleChat()" :opened="chat.show" :alignment="alignment" :bubble="bubble"
      :badge="badge" :textBadge="textBadge" :closeCross="closeCross" :show-cta="callToAction.showCta" 
      @crossclicked="handleCrossClicked"/>
  </div>
</template>

<script>
import Container from "./Container";
import Bubble from "./Bubble";
import CallToAction from "./CallToAction";
import { getConfig, parseResult } from "../helpers/configParser";
import UAParser from "ua-parser-js"
import { getDefaultVariables, getUserIdFromUrl } from '../helpers/metadata'


export default {
  name: "Wrapper",
  components: {
    Container,
    Bubble,
    CallToAction,
  },
  props: {
    apiKey: { type: String, requiered: true, default: "default" },
    bot: { type: String, requiered: true, default: "bot" },
    metadata: { type: String, default: "{}" },
    user: { type: String, default: undefined },
    userLanguage: { type: String, default: "" },
    fullScreenWidget: { type: Boolean, default: undefined },
    allwaysAutoStart: { type: Boolean, default: undefined },
    css: { type: String, default: "" },
    centeredChat: { type: Boolean, default: true },
    soft_scroll: { type: Boolean, default: false },
    close_alert: { type: Boolean, default: false },
    send_view_stanzas: { type: Boolean, default: false },
    send_read_enabled: { type: Boolean, default: false },
    virtual_user_by_cookie: { type: Boolean, default: false },
    scroll_down_indicator: { type: Boolean, default: false },
    autoOpenChatbot: { type: Boolean, default: false },
    lazy: { type: Boolean, default: undefined },
    singleAvatar: { type: Boolean, default: false },
    chatViewVersion: { type: String, default: "old" },
    sdkUrl: { type: String, default: undefined },
    fastMenu: {
      type: Array,
      default: function () {
        return [];
      },
    },
    plainText: { type: String, default: "Start chat" },
    payload: { type: String, default: "POSTBACK_INITCHAT" },
    css_code: { type: String, default: "" },
    custom_font: {type: String, default: "" },
    custom_font_name: {type: String, default: ""},
  },
  data() {

    return {
      showWrapper: false,
      IMbee: null,
      app: null,
      metaInjection: true,
      rememberState: false,
      alignment: "right",
      fullScreen: false,
      autoStart: true,
      header: {
        show: true,
        showImage: false,
        image: null,
        text: "Chatbot Imbee",
        color: "#BE1E18",
        fontSize: "16px",
        fontWeight: "normal",
        fontFamily: "Arial,Helvetica,sans-serif,Lato",
        backgroundColor: "#FFF",
        headerTop: "0px",
        headerLeft: "0px",
        subtitleText: "",
        subtitleColor: "#ee0000",
        fontSubtitleSize: "14px",
        fontSubtitleWeight: "bolder",
        fontSubtitleFamily: "Arial,Helvetica,sans-serif,Lato",
        imageSize: "80%",
        subtitleTop: "0px",
        subtitleLeft: "0px"
      },
      cookieBanner: {
        show: false,
        cookiesAllowedCookie: getCookie("cookiesAllowed"),
      },
      footer: {
        show: false,
      },
      humanizacion: {
        show: false,
      },
      chat: {
        customCss: "",
        show: false,
        lazyLoading: true,
        width: "380px",
        height: "630px",
        backgroundColor: "#fffdfe",
        verticalPadding: "100px",
        horizontalPadding: "20px",
        openOnShow: false,
        
        showInputOnStart: false,
        loaded: false,
        placeholder: "Escribe aquí...",
        addUa: true,
        uaData: null,
        options: {
          widgetVersion: "1.0.11",
          singleAvatar: true,
          autofocus: true,
          copyButton: true,
          autocomplete: true,
          toggleTime: true,
          htmlActive: false,
          leftProfile: "https://s3.eu-west-3.amazonaws.com/static.imbee.xyz/recursos/profile_icon_imbee.png",
          rightProfile: "",
        },
        speech: {
          enable: false,
          lang: "es",
          always: false,
          voice: null,
        },
        recognition: {
          enable: false,
          lang: "es",
          placeholder: "Escuchando...",
          autoSend: false,
        },
        
      },
      callToAction: {
        show: false,
        showCta: null,
        delay: 3000,
        animation: "fade",
        width: "240px",
        text: "Can I help you?",
        fontFamily: "Arial,Helvetica,sans-serif,Lato",
        fontSize: "14px",
        fontColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255, 255, 255)",
        boxShadow: "",
        verticalPadding: "20px",
        horizontalPadding: "20px",
      },
      textBadge: {
        show: false,
        animation: "fade",
        text: "ONLINE HELP",
        color: "rgb(231, 90, 79)",
        backgroundColor: "rgb(60, 60, 60)",
        fontSize: "10px",
        fontFamily: "Arial",
        fontWeight: "bold",
      },
      closeCross: {
        show: false,
        color: "white",
        backgroundColor: "rgba(170, 170, 170, 0.68)",
        fontSize: "14px",
        fontFamily: "Arial",
        fontWeight: "bold",
        size: "29px",
        top: "-23px",
        right: "-16px", 
      },
      badge: {
        show: false,
        text: 0,
        color: "rgb(231, 90, 79)",
        backgroundColor: "rgb(60, 60, 60)",
      },
      bubble: {
        show: false,
        delay: 1000,
        sameDirection: false,
        closeIcon: 2,
        color: "white",
        backgroundColor: "red",
        bubbleAnimation: "bounceUp",
        bubbleTransition: "",
        bubbleInTransition: "",
        bubbleOutTransition: "",
        verticalPadding: "20px",
        horizontalPadding: "20px",
        image:
          "https://s3.eu-west-3.amazonaws.com/imbee.xyz/chat/2123178a54c2618a9905e9010d076900f28f5a9a/70705670e816e9d2ca4f6aed75ccf4c671dea7ff.png",
        showImage: false,
        boxShadow: "0px 1px 25px rgba(31, 31, 31, 0.5)",
      },
      loader: {
        show: true,
        loading: false,
        type: "GridLoader",
        color: "rgb(231 90 79)",
        backgroundColor: "#fffdfe",
      },
      connection: {
        connected: false,
        connecting: false,
        disconnected: true,
      },
      userCookie: {
        expires: "1D",
        name: "imbee",
      }
    };
  },
  computed: {
    userId: function () {
      return this.user || this.handleCookie();
    },
  },
  methods: {
    show(newConfig) {
      if (!this.autoStart && !this.allwaysAutoStart) {
        this.handleStart();
        this.autoStart = true;
        return;
      }
      this.bubble.show = true;
      if (
        (this.chat.autoOpenChatbot || this.chat.openOnShow && localStorage.imbee_widget_opened == "true") ||
        localStorage.imbee_widget_skip_payload == "true"
      ) {

        if (this.chat.autoOpenChatbot) {
          setTimeout(()=> {
            this.handleInitChat(newConfig);
            this.chat.show = true;
          localStorage.imbee_widget_skip_payload = false;
     
          }, 3000)

        } else {
          this.handleInitChat(newConfig);

          setTimeout(() => {
            this.chat.show = true;
            localStorage.imbee_widget_skip_payload = false;
          }, 800);
        }
        
      }
    },

    hide() {
      this.bubble.show = false;
      this.chat.show = false;
    },
    open(newConfig) {
      if (!this.chat.show && this.IMbee) this.IMbee.imbeeScrollBottom();
      localStorage.imbee_widget_opened = true;
      this.chat.show = true;
      this.handleInitChat(newConfig);
    },
    close() {
      localStorage.imbee_widget_opened = false;
      this.chat.show = false;
    },
    toggleChat() {
      if (!this.chat.show && this.IMbee) this.IMbee.imbeeScrollBottom();
      localStorage.imbee_widget_opened = !this.chat.show;
      this.chat.show = !this.chat.show;
      this.handleInitChat();
    },
    handleInitChat(newConfig) {
      let lazy = this.lazy != undefined ? this.lazy : this.chat.lazyLoading;
      if (newConfig && newConfig.contract) {        
        this.initialiceSDK(this.IMbee, newConfig.contract);
        return
      }

      if (!this.chat.loaded && lazy && !this.loader.loading) {
        if (this.IMbee) {
          this.initialiceSDK(this.IMbee);
        } else {
          setTimeout(() => {
            this.handleInitChat();
          }, 100);
        }
      }
    },
    handleCookie() {
      let cookie = this.$cookie.get(this.userCookie.name);
      let user = null;
      if (!cookie) {
        this.$cookie.set(this.userCookie.name, this.genCookie(), {
          expires: this.userCookie.expires,
        });
        cookie = this.$cookie.get(this.userCookie.name);
      }
      return cookie;
    },
    insertSDKScript() {
      let imbeeScript = document.createElement("script");
      let url = this.sdkUrl ? this.sdkUrl : process.env.NEW_SDK_URL;
      let lazy = this.lazy != undefined ? this.lazy : this.chat.lazyLoading;
      imbeeScript.setAttribute("src", url);
      document.head.appendChild(imbeeScript);

      let initValue =
        lazy && !this.fullScreen
          ? (IMbee) => {
            this.IMbee = IMbee;
          }
          : this.initialiceSDK;

      window.imbeeOptions = {
        metaInjection: this.metaInjection,
        chatViewVersion: this.chatViewVersion == "old" ? "old" : "new",
        divId: "imbeeWidget",
        myCss: this.css ? this.css : this.chat.customCss,
        init: initValue,
      };
    },
    initialiceSDK(IMbee, newContract) {
      this.IMbee = IMbee;
      this.loader.loading = true;

      window.imbeeScrollBottom = this.IMbee.imbeeScrollBottom;
      const { options, recognition, speech} = this.chat;




      this.IMbee.init(
        process.env.API_URL,
        process.env.MESSENGER_URL,
        IMbee.ENVIRONMENT.Production,
        this.apiKey,
        this.chat.placeholder
      );

      const BOT_ID = this.bot;
      var USER_ID = this.userId;
      this.newContractId = newContract;
      const USER_LANGUAGE = this.userLanguage;
      const that = this;
      const VIRTUAL_USER_BY_COOKIE = options.virtual_user_by_cookie;

      const urlUserID = getUserIdFromUrl()
      
      if (urlUserID) {

        if (options.virtual_user_by_cookie) {

        USER_ID = this.userId;

        } else {

        USER_ID = urlUserID;
        }
      }

      IMbee.externalUserRegistration(USER_ID, function (data) {
        IMbee.chatCreate(BOT_ID, function (conversationId, created) {
          that.chat.conversation = conversationId;
          that.chat.created = created;
          var op = {
            conversationTarget: conversationId,
            conversationLeftProfile: options.leftProfile,
            conversationRightProfile: options.rightProfile,
            widgetVersion: "1.0.11",
            singleAvatar: options.singleAvatar,
            chatViewVersion: that.chatViewVersion,
            autofocus: options.autofocus,
            copyButton: options.copyButton,
            copyButtonText: options.copyButtonText,
            autocomplete: options.autocomplete,
            toggleTime: options.toggleTime,
            htmlActive: options.htmlActive,
            soft_scroll: options.soft_scroll,
            close_alert: options.close_alert,
            send_view_stanzas: options.send_view_stanzas,
            send_read_enabled: options.send_read_enabled,
            virtual_user_by_cookie: options.virtual_user_by_cookie,
            scroll_down_indicator: options.scroll_down_indicator,
           
            css_code: options.css_code,
            custom_font: options.custom_font,
            custom_font_name : options.custom_font_name,

            userLanguage: USER_LANGUAGE,
            centeredChat: that.centeredChat,
            speechSynthesis: {
              always: speech.always,
              enable: speech.enable,
              lang: speech.lang,
              voice: speech.voice,
            },
            recognition: {
              enable: recognition.enable,
              lang: recognition.lang,
              placeholder: recognition.placeholder,
              autoSend: recognition.autoSend,
            },
            onButtonClicked: function (button) {
              window.imbeeWidget.onButtonClicked(button);
            },
            onMessageReceived: function (message) {
              that.unreadMessages = message
                .getConversation()
                .getUnreadMessagesNumber();

              if (message && message.attributes && message.attributes.content && message.attributes.content.type === "url") {
                if (message.attributes.content.data.type === "internal") {
                  localStorage.imbee_widget_skip_payload = "true";
                  that.chat.openOnShow = true;
                  localStorage.imbee_widget_opened = "true";
                  window.location.href = message.attributes.content.data.url;
                }
              }

              window.imbeeWidget.onMessageReceived(message);
            },
            onMessageUpdated: function (message) {
              window.imbeeWidget.onMessageUpdated(message);
            },
            onChatConnectionChanged: {
              onChatConnected: function () {
                that.connection.connected = true;
                that.connection.connecting = false;
                that.connection.disconnected = false;
                that.chat.loaded = true;
                that.loader.loading = false;
                that.loader.show = false;
                that.IMbee.imbeeScrollBottom();
                window.imbeeWidget.onChatConnected(that.chat.conversation);
              },
              onChatConnecting: function () {
                that.connection.connecting = true;
                that.connection.connected = false;
                that.connection.disconnected = false;
                window.imbeeWidget.onChatConnecting(that.chat.conversation);
              },
              onChatDisconnected: function () {
                that.connection.connected = false;
                that.connection.connecting = false;
                that.connection.disconnected = true;
                window.imbeeWidget.onChatDisconnected(that.chat.conversation);
              },
            },
            setMenuView: function () {
              var menu = that.fastMenu;
              if (menu.length > 0) {
                var content = "";
                for (let i = 0; i < menu.length; i++) {
                  if (menu[i].type == "message") {
                    content +=
                      '<a class="fast-button c-chatbot__body__actions__menu__content__item" data-type="' +
                      menu[i].type +
                      '" data-text="' +
                      menu[i].plainText +
                      '" data-payload="' +
                      menu[i].payload +
                      '" data-conversation="' +
                      conversationId +
                      '"><span class="' +
                      menu[i].icon +
                      '"></span>' +
                      menu[i].label +
                      "</a>";
                  } else {
                    content +=
                      '<a class="c-chatbot__body__actions__menu__content__item" href="' +
                      menu[i].url +
                      '" target="_top"><span class="' +
                      menu[i].icon +
                      '"></span>' +
                      menu[i].label +
                      "</a>";
                  }
                }
                var fileBtn =
                  '<button id="imbee-file-trigger" class="imbee-menu-btn imbee-file-trigger"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" /><path d="M0 0h24v24H0z" fill="none" /></svg></button>';
                return (
                  '<input type="checkbox" id="c-chatbot__body__actions__menu_checker" class="c-chatbot__body__actions__menu_checker"><label for="c-chatbot__body__actions__menu_checker" class="c-chatbot__body__actions__menu__trigger"><div class="icon-fast-menu"><svg xmlns="http://www.w3.org/2000/svg" fill="' +
                  this.colorData +
                  '" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg></div></label><div class="c-chatbot__body__actions__menu__content"><div class="c-chatbot__body__actions__menu__content__items">' +
                  content +
                  '</div></div><label for="c-chatbot__body__actions__menu_checker" class="c-chatbot__body__actions__menu-tohide"></label>' +
                  fileBtn
                );
              } else {
                return null;
              }
            },
           

          };
          that.app = IMbee.getApp(op);
          that.app.start();
          if (that.app.showInputOnStart == false) {
            that.app.callHideInput();
          }

          if (that.payload) {

            let metadata = {}
            try {
              metadata = JSON.parse(that.metadata);
              if (that.newContractId) {
                metadata.variables.forEach((a) => { if (a.label == 'contract_id') a.value = that.newContractId });
              }
            } catch (e) {
              console.debug("The metadata has errors")
              console.debug(e)
            }

            metadata.variables = [
              ...getDefaultVariables(),
              ...(metadata.variables ?? []),
            ]
           

            if (VIRTUAL_USER_BY_COOKIE && urlUserID) {
              metadata.variables.push({
                label: "user",
                value: urlUserID,
              });
            }

            var postback = that.payload;
            var plainText = that.plainText;
            var content = {
              type: IMbee.MESSAGE_CONTENT_TYPE.MESSAGE,
              plainText: plainText,
            };
            if (that.chat.addUa) {
              const parser = new UAParser();
              that.chat.uaData = JSON.stringify({
                device: parser.getDevice(),
                os: parser.getOS(),
                engine: parser.getEngine(),
                browser: parser.getBrowser(),
              });

              postback = postback.concat("=" + that.chat.uaData);
            }

            that.app.sendMessageWithFlags(
              conversationId,
              content,
              postback,
              IMbee.MESSAGE_FLAG.INVISIBLE,
              metadata
            );
          }
        });
      });
    },
    genTransitionClassNames() {
      const animation = this.bubble.bubbleAnimation
        .match(/([A-Z]?[^A-Z]*)/g)
        .slice(0, -1);

      var directionIn = animation[1];
      var directionOut = animation[1];

      if (animation.length > 1) {
        if (!this.bubble.sameDirection) {
          switch (directionIn) {
            case "Up":
              directionOut = "Down";
              break;
            case "Down":
              directionOut = "Up";
              break;
            case "Left":
              directionOut = "Right";
              break;
            case "Right":
              directionOut = "Left";
              break;
            default:
              break;
          }
        }

        if (animation.length == 2) {
          this.bubble.bubbleInTransition = `${animation[0]}In${directionIn}`;
          this.bubble.bubbleOutTransition = `${animation[0]}Out${directionOut}`;
        } else {
          this.bubble.bubbleInTransition = `${animation[0]}In${directionIn + animation[2]
            }`;
          this.bubble.bubbleOutTransition = `${animation[0]}Out${directionOut + animation[2]
            }`;
        }
      } else {
        this.bubble.bubbleInTransition = `${animation[0]}In`;
        this.bubble.bubbleOutTransition = `${animation[0]}Out`;
      }

      this.bubble.bubbleTransition = animation[0];
    },
    genCookie() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now();
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    handleStart() {
      setTimeout(() => {
        this.show();
        setTimeout(() => {
          if (this.callToAction.showCta == null && this.callToAction.show) {
            this.callToAction.showCta = true;
          }
        }, Number(this.callToAction.delay));
      }, Number(this.bubble.delay));
    },
    handleKill: function () {
      let el = document.querySelector('imbee-chat');
      window.imbeeTemp = {};
      window.imbeeTemp.apiKey = document.querySelector('imbee-chat').getAttribute('api-key');
      window.imbeeTemp.bot = document.querySelector('imbee-chat').getAttribute('bot');

      let placeholderEl = document.createElement('div');
      placeholderEl.classList.add('imbee-placeholder');
      el.replaceWith(placeholderEl);

    },

    handleCrossClicked: function() {
      this.chat.show = false;
    }

  },
  created() {
    window.imbeeLog = (window.imbeeLog ?? "") + " \n" + "created";
  },
  beforeMount() {
    window.imbeeLog += " \n" + "beforeMount " + this.chat.options.css_code;
    if (window.widget_styles && window.widget_styles.configuration_version) {
      parseResult(this, window.widget_styles);
    } else {
      getConfig(this, this.bot);
    }
  },
  mounted() {
    window.imbeeLog += "AHOY"+ " \n" + "mounted, custom_css: " + this.chat.options.css_code;
    window.imbeeLog += " \n" + "mounted, custom_font: " + this.chat.options.custom_font;

    var newsStyleSheet = document.createElement('style')
    newsStyleSheet.type = "text/css"
    newsStyleSheet.classList.add('css_code_widget');
    const imbeeChat = document.querySelector("imbee-chat")
    window.imbeeLog += " " + imbeeChat;
    imbeeChat.appendChild(newsStyleSheet);
    newsStyleSheet.innerHTML = this.chat.options.css_code
    
    var customFontStyleSheet = document.createElement('style');
    customFontStyleSheet.type ="text/css"
    customFontStyleSheet.classList.add('css_custom_font');
    imbeeChat.appendChild(customFontStyleSheet);
    customFontStyleSheet.innerHTML = this.chat.options.custom_font;

    imbeeChat.setAttribute("centered-chat", "true");

    if (!window.imbeeWidget) window.imbeeWidget = {};
    window.imbeeWidget.wrapper = this;
    window.imbeeWidget.onButtonClicked = (button) => {
      if (button.type == "url") {
        window.open(button.payload);
      }
    };
    window.imbeeWidget.onChatConnected = () => { };
    window.imbeeWidget.onChatConnecting = () => { };
    window.imbeeWidget.onChatDisconnected = () => { };
    window.imbeeWidget.onMessageReceived = () => { };
    window.imbeeWidget.onMessageUpdated = () => { };
    window.imbeeWidget.onShow = () => { };
    window.imbeeWidget.onHide = () => { };
    window.imbeeWidget.show = (newConfig) => {
      this.show(newConfig);
    };
    window.imbeeWidget.hide = () => {
      this.hide();
    };
    window.imbeeWidget.showTopBadge = () => {
      this.textBadge.show = true;
    };
    window.imbeeWidget.hideTopBadge = () => {
      this.textBadge.show = false;
    };
    window.imbeeWidget.showCloseCross = () => {
      this.closeCross.show = true;
    };
    window.imbeeWidget.hideCloseCross = () => {
      this.closeCross.show = false;
    };
    window.imbeeWidget.showCta = () => {
      this.callToAction.show = true;
      this.callToAction.showCta = true;
    };
    window.imbeeWidget.hideCta = () => {
      this.callToAction.showCta = false;
    };
    window.imbeeWidget.open = (newConfig) => {
      if (this.bubble.show) this.open(newConfig);
    };
    window.imbeeWidget.close = () => {
      if (this.bubble.show) this.close();
    };
    window.imbeeWidget.reloadConfig = () => {
      parseResult(this, window.widget_styles, false);
    };
    window.imbeeWidget.version = "1.0.11";
    window.imbeeRemove = () => {
      this.handleKill();
    };
    window.imbeeAddBack = (newConfig) => {
      window.imbeeLog += `\n` + ` added Back`;

      let  apiKey = newConfig && newConfig.apiKey ? newConfig.apiKey : window.imbeeTemp.apiKey;

      let  bot = newConfig && newConfig.bot ? newConfig.bot : window.imbeeTemp.bot;
      let newUser = newConfig && newConfig.user ? newConfig.user : "";
      let newMetadata = newConfig && newConfig.metadata ? newConfig.metadata : "";

      let newElement = document.createElement('imbee-chat');
      newElement.setAttribute('api-key', apiKey);
      newElement.setAttribute('bot', bot);
      newElement.setAttribute('chat-view-version', "new");
      newElement.setAttribute('single-avatar', "true");
      if (newUser) newElement.setAttribute('user', newUser);
      if (newMetadata) newElement.setAttribute('metadata', newMetadata);

      if (newConfig && newConfig.forceFullScreenTo) {
        newElement.setAttribute('full-screen-widget', `${newConfig.forceFullScreenTo}`);
      }

      let placeholderEl = document.querySelector('.imbee-placeholder');
      placeholderEl.replaceWith(newElement);

      if (newConfig && newConfig.notToOpen) {
   
      } else {

        window.imbeeWidget.show(newConfig);
      }

    }

    window.imbeeReload = (newConfig) => {
      window.imbeeLog += `\n` + ` reloaded`;
      window.imbeeRemove();
      window.imbeeAddBack(newConfig);
      if (newConfig && newConfig.notToOpen) {
       
      } else  {

        window.imbeeWidget.open(newConfig);

      }
    }
  },
  updated() {
    window.imbeeLog += " \n" + "updated, custom css: " + this.chat.options.css_code;

    let styleSheet = document.querySelector('.css_code_widget');
    styleSheet.innerHTML = this.chat.options.css_code;
    
    let fontStyleSheet = document.querySelector('.css_custom_font');
    fontStyleSheet.innerHTML = this.chat.options.custom_font;

  },
  unmounted() {
    window.imbeeLog += " \n" + "umounted";
  }
};

function getCookie(name) {
  const nameLenPlus = (name.length + 1);
  return document.cookie
    .split(';')
    .map(c => c.trim())
    .filter(cookie => {
      return cookie.substring(0, nameLenPlus) === `${name}=`;
    })
    .map(cookie => {
      return decodeURIComponent(cookie.substring(nameLenPlus));
    })[0] || null;
}
</script>

<style scoped>
.w-imbee-wrapper {
  position: fixed;
  height: 0px;
  width: 0px;
  box-sizing: border-box;
  z-index: 2147483647;
  border-radius: 12px;
}

.w-imbee-container[data-fullscreen="true"],
.w-imbee-wrapper[data-fullscreen="true"] {
  max-height: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  bottom: 0 !important;
  right: 0 !important;
  border-radius: 0px !important;
}

.w-imbee-wrapper[data-open="true"] {
  min-height: 150px;
  height: calc(100% - 120px);
  width: 100%;
}

.w-imbee-wrapper *,
.w-imbee-wrapper *:before,
.w-imbee-wrapper *:after {
  box-sizing: inherit;
  font-family: sans-serif;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

@media screen and (max-width: 568px) {
  .w-imbee-wrapper[data-open="true"] {
    border-radius: 0;
    bottom: 0 !important;
    left: initial !important;
    max-height: 100% !important;
    height: 100% !important;
    right: 0 !important;
    top: initial !important;
    width: 100% !important;
    max-width: 100% !important;
  }
}

@import "../animations/vue2-animate.css";
</style>


// WEBPACK FOOTER //
// Wrapper.vue?4fc3c258